import { AlertCircle } from 'lucide-react';
import { summarizeRejectionReason } from '../utils/rejectionReason';

interface RejectionReasonTagProps {
  reason: string | null | undefined;
}

/**
 * Renders a rejection reason compactly.
 *
 * Meta rejections are stored as the raw Graph API error JSON; showing that in
 * a table cell buries the row. We show a short label and keep the full
 * payload — readable summary plus raw JSON — in the tooltip.
 */
export function RejectionReasonTag({ reason }: RejectionReasonTagProps) {
  const { label, detail, isMetaError } = summarizeRejectionReason(reason);
  if (!label) return null;

  if (!isMetaError) {
    return <p className="mt-1 text-xs text-red-500 dark:text-red-400">{label}</p>;
  }

  return (
    <span
      title={detail}
      className="mt-1 inline-flex items-center gap-1 max-w-full px-2 py-0.5 rounded-full bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-300 text-[11px] font-medium cursor-help"
    >
      <AlertCircle className="h-3 w-3 shrink-0" />
      <span className="truncate">{label}</span>
    </span>
  );
}
